<template>
  <main class="relative isolate min-h-full">
    <div class="mx-auto max-w-7xl px-6 py-32 text-center sm:py-40 lg:px-8">
      <p class="text-base font-semibold leading-8 text-blue-500">404</p>
      <h1
        class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl"
      >
        Sidan kunde inte hittas
      </h1>
      <p class="mt-4 text-base text-gray-900/70 sm:mt-6">
        Vi är ledsna, vi kunde inte hitta sidan du letade efter.
      </p>
      <div class="mt-10 flex justify-center">
        <router-link
          to="/admin"
          class="text-sm font-semibold leading-7 text-gray-900"
          ><span class="mr-1" aria-hidden="true">&larr;</span>Tillbaka till
          start</router-link
        >
      </div>
    </div>
  </main>
</template>
